import { Uuid } from "@/domains/global/identifiers";
import { resolveSyncModelNamespacedUuid } from "@/modules/uuid/sync-models/resolveSyncModelNamespacedUuid";
import { SyncModelKind } from "@/store/sync/types";

export const resolveSourceIdForSessionArtifact = ({
  sessionId,
  sessionArtifactId,
}: {
  sessionId: Uuid;
  sessionArtifactId: Uuid;
}): Uuid => {
  return resolveSyncModelNamespacedUuid({
    modelKind: { value: SyncModelKind.Source },
    uuids: [sessionId, sessionArtifactId],
  });
};
